import SkeletonBar from "../../shared/SkeletonBar";

export function OpportunityCompactCardSkeleton() {
    return (
        <div
            className="flex w-full min-w-0 flex-col justify-center rounded-xl border border-slate-200/70 bg-white px-4 py-3 shadow-sm"
            aria-hidden
        >
            <SkeletonBar className="h-4 w-36 max-w-full" />
            <div className="mt-2 flex flex-wrap gap-1.5">
                <SkeletonBar className="h-5 w-16 rounded-full" />
                <SkeletonBar className="h-5 w-20 rounded-full" />
                <SkeletonBar className="h-5 w-14 rounded-full" />
            </div>
        </div>
    );
}

export default function OpportunityPreviewSkeletons({
    count = 8,
    label = "Loading trends",
}) {
    return (
        <div
            className="grid grid-cols-1 gap-3 md:grid-cols-2 md:gap-4"
            aria-busy="true"
            aria-label={label}
            role="status"
        >
            <span className="sr-only">{label}</span>
            {Array.from({ length: count }, (_, index) => (
                <OpportunityCompactCardSkeleton key={index} />
            ))}
        </div>
    );
}
